<template>
  <div class="panel">
    <div class="header actions-header">
      <AutoSwap
        :launch-cfg="launchCfg"
        @cfg="$emit('cfg', $event)"
      />
    </div>

    <div class="body actions-body">
      <Dev
        :entity="entity"
        :is-launched="isLaunched"
        :dev-wallet="devWallet"
        :dev-wallet-options="devWalletOptions"
        @own="$emit('own', $event)"
      />

      <Buttons
        :entity="entity"
        :is-local="isLocal"
        :is-launched="isLaunched"
        :dev-wallet="devWallet"
        :dev-wallet-options="devWalletOptions"
        @launch="$emit('launch', $event)"
        @copy="$emit('copy', $event)"
        @delete="$emit('delete', $event)"
      />
    </div>
  </div>
</template>

<script setup>
import AutoSwap from './autoswap.vue'
import Dev from './dev.vue'
import Buttons from './buttons.vue'

defineProps({
  entity: { type: Object, default: null },
  isLocal: { type: Boolean, default: false },
  isLaunched: { type: Boolean, default: false },
  devWallet: { type: String, default: '' },
  devWalletOptions: { type: Array, default: () => [] },
  stats: { type: Object, default: null },
  launchCfg: {
    type: Object,
    default: () => ({ buyOn: false, buyMs: 0, sellOn: false, sellMs: 0 }),
  },
  guardNonce: { type: Number, default: 0 },
})

defineEmits(['launch', 'copy', 'delete', 'own', 'cfg'])
</script>

<style scoped>
.panel{
  background:#111;
  border:1px solid #222;
  border-radius:8px;
  overflow:hidden;
  height:100%;
}

.header{
  padding:12px 16px;
  background:#1a1a1a;
  border-bottom:1px solid #222;
  font-weight:600;
  font-size:14px;
  color:#fff;
}

.body{ padding:8px; }

.actions-body{
  display:flex;
  flex-direction:column;
  gap:10px;
}

.actions-header{
  display:flex;
  align-items:center;
  justify-content:space-between;
  gap:8px;
}
</style>
